<div id="action-plan-responses" class="{{moduleKey}}" data-module-title="{{{pt moduleTitle}}}" data-done-total="{{doneTotal}}" data-response-total="{{responseTotal}}" data-action-plan-items-total="{{actionPlanItemsTotal}}">
  <a id="close" href="#menu/home" role="button">&times;</a>
  <div id="responses-info">
    <div class="heading"></div>
    <h4>{{t 'actionPlanResponses.subheader'}}</h4>
    <span class="name">{{t moduleTitle}}</span>

    <div class="steps-description">
      <p>{{t 'actionPlanResponses.done'}}</p>
    </div>

    <div class="completion-header">
      <span class="stats">{{stepsComplete}}</span>
      <span class="header-btn">{{t 'actionPlanResponses.now'}}</span>
      <span class="header-btn">{{t 'actionPlanResponses.later'}}</span>
    </div>
  </div>

  <div id="responses-incomplete">
    <p role="region">{{t 'actionPlanResponses.incomplete'}}</p>
  </div>
</div>
